import React, { useState } from "react";
import { OverlayTrigger, Tooltip, InputGroup, Image } from "react-bootstrap";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import {
  SearchableList,
  FieldDropSide,
  SliderPanel,
  ManageRkaasLayout,
  CsplTable as Table,
  LoaderWrapper,
  FormControlSearch,
} from "../../../components";
import {
  MANAGE_RKAAS_ROUTES,
  formFields,
  FLOW_TYPES,
  OPTIONS_DATA_MAPPER,
  INVESTMENT_RECORDS_TO_FETCH,
  getAdvancedPathWithParam,
} from "../../../utils";
import { getMasterInvestmentBySearchCriteria } from "../../../services";
import { useDeepEffect } from "../../../abstracts";
import InfiniteScroll from "react-infinite-scroller";
import AddInvestmentContainer from "../Investment/AddInvestmentContainer";
import MasterInvestmentFilter from "../Investment/ManageInvestment/MasterInvestmentFilter";
import CustodianCard from "./CustodianCard";
const columns = [
  {
    label: "Investment Name",
    className: "column-investment-name",
    columnName: "name",
    isSortable: true,
    orderBy: "",
    link: MANAGE_RKAAS_ROUTES.ADD_INVESTMENT,
  },
  {
    label: "Investment Type",
    className: "column-investment-type",
    columnName: "type",
    dataMapper: OPTIONS_DATA_MAPPER.INVESTMENT_TYPES,
  },
  {
    label: "Ticker",
    className: "column-investment-ticker",
    columnName: "ticker",
  },
  {
    label: "CUSIP",
    className: "column-investment-cusip",
    columnName: "cusip",
  },
  {
    label: "Investment Status",
    className: "column-investment-status",
    columnName: "status",
    dataMapper: OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER,
  },
];

const mockData = [
  {
    id: 1,
    custodianName: "Thop manoj",
    custodianCode: "SBHSNXHHSJJNHXSJ",
    associatedPlans: "06",
  },
  {
    id: 2,
    custodianName: "Thoppest manoj",
    custodianCode: "SBHSNXHHSJJNHXSJ",
    associatedPlans: "06",
  },
  {
    id: 3,
    custodianName: "Thoppest manoj",
    custodianCode: "SBHSNXHHSJJNHXSJ",
    associatedPlans: "06",
  },
];
const ManageCustodian = (props) => {
  const { history } = props;
  const [filteredValues, setFilteredValues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [request, setRequest] = useState({
    search: "",
    from: 0,
    to: INVESTMENT_RECORDS_TO_FETCH,
  });
  // useDeepEffect(() => {
  //   setIsLoading(true);
  //   getMasterInvestmentBySearchCriteria(request)
  //     .then((response) => {
  //       if (response.length < INVESTMENT_RECORDS_TO_FETCH)
  //         setStopInfiniteScroll(true);
  //       if (append)
  //         setFilteredValues((filteredValues) => {
  //           return [...filteredValues, ...response];
  //         });
  //       else setFilteredValues(response);
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       setIsLoading(false);
  //     });
  // }, [request]);

  const onFormSubmit = (values) => {
    setAppend(false);
    setStopInfiniteScroll(false);
    setRequest({
      search: values.search,
      investmentType: values.investmentType,
      investmentStatus: values.investmentStatus,
      from: 0,
      to: INVESTMENT_RECORDS_TO_FETCH,
    });
  };

  // const onAddClick = () => {
  //   const { history } = props;
  //   history.push(
  //     getAdvancedPathWithParam({
  //       path: MANAGE_RKAAS_ROUTES.ADD_INVESTMENT,
  //       pathParam: [FLOW_TYPES.ADD],
  //     })
  //   );
  // };

  const buttons = [
    {
      label: "Add Custodian",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      link: getAdvancedPathWithParam({
        path: MANAGE_RKAAS_ROUTES.ADD_CUSTODIAN,
        pathParam: [FLOW_TYPES.SAVE],
      }),
    },
  ];

  return (
    <ManageRkaasLayout
      layoutHeader="Manage Custodian"
      buttons={buttons}
      pageFlow={FLOW_TYPES.ADD}
    >
      <>
        <LoaderWrapper isLoading={isLoading}>
          {/* {isEmpty(filteredValues) && (
          <AddPlans
            menu="plan"
            subMenu="manageInvestmentsPlan"
            content="No Investments"
            buttonLabel="New Investment"
            onPrimaryClick={onAddClick}
          />
        )} */}

          <div className="trade-container">
            <div className="mb-16">
              {/* <div className="search-bar mb-16"> */}
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text className="plan-search-button">
                    <Image src="/assets/icons/svg/search.svg" width="14px" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControlSearch
                  type="search"
                  placeholder="Search custodian"
                  // onChange={(e) => {
                  //   setFieldValue(fields.search, e.target.value);
                  // }}
                />
              </InputGroup>

              <div className="custodian-card-list-wrapper">
                {mockData.map((item, index) => {
                  return (
                    <Link
                      to={getAdvancedPathWithParam({
                        path: `${MANAGE_RKAAS_ROUTES.CUSTODIAN_DETAIL}`,
                        pathParam: [item.id],
                      })}
                      style={{ textDecoration: "none" }}
                    >
                      <CustodianCard
                        custodianName={item.custodianName}
                        custodianCode={item.custodianCode}
                        associatedPlans={item.associatedPlans}
                      />
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </LoaderWrapper>
      </>
    </ManageRkaasLayout>
  );
};

export default ManageCustodian;
